import React from 'react';
import { MultiApp, useAppConfig } from '@/config/context';


export interface AppSlotProps {
  apps: MultiApp[];
}

// @ts-ignore
export const AppSlot: React.FC<AppSlotProps> = (props) => {
  const config = useAppConfig();
  const enable = props.apps?.includes(config.currentApp);
  return enable ? props.children : null;
};

/**
 * 区分不同版本执行函数
 * @param func
 * @param apps
 * @returns
 */
export const runFuncWithApp = (func: () => any, apps: MultiApp[]) => {
  const currentApp = process.env.APP_VERSION as MultiApp;

  if (apps.includes(currentApp)) {
    return func?.();
  }

  return null;
};
